var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6363_63850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.744 43.7471H27.9411C25.947 43.7483 24.035 44.541 22.625 45.951C21.215 47.361 20.4224 49.273 20.4211 51.267V186.877C20.4224 188.871 21.215 190.783 22.625 192.193C24.035 193.603 25.947 194.396 27.9411 194.397H175.744C177.738 194.396 179.65 193.604 181.06 192.194C182.47 190.784 183.263 188.872 183.264 186.877V51.267C183.263 49.2728 182.47 47.3607 181.06 45.9507C179.65 44.5407 177.738 43.7481 175.744 43.7471Z",
    fill: "#E3ECFB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6363_63850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.013 147.273H37.6718C33.5189 147.273 30.1519 143.906 30.1519 139.753V19.934C30.1519 15.7811 33.5189 12.4141 37.6718 12.4141H166.013C170.166 12.4141 173.533 15.7811 173.533 19.934V139.753C173.533 143.906 170.166 147.273 166.013 147.273Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5327 142.134V22.3158C32.5327 18.1629 35.8997 14.7959 40.0526 14.7959H168.394C169.861 14.7959 171.224 15.2222 172.381 15.9483C171.051 13.8283 168.7 12.415 166.013 12.415H37.6718C33.5189 12.415 30.1519 15.7821 30.1519 19.935V139.754C30.1519 142.441 31.5651 144.792 33.6851 146.122C32.959 144.965 32.5327 143.601 32.5327 142.135V142.134Z",
    fill: "url(#paint0_linear_6363_63850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9946 83.1018L89.3086 107.417H64.9946V83.1018Z",
    fill: "url(#paint1_linear_6363_63850)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.264 109.421V53.4778L173.533 43.7463V109.421L183.264 109.421Z",
    fill: "#E3ECFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.344 25.1562C108.594 25.5469 114.453 28.6719 118.75 32.9688C123.828 38.4375 126.563 45.0781 126.563 52.8906C126.563 59.1406 124.219 65 120.313 70.0781C116.406 74.7656 110.938 78.2813 104.688 79.4531C98.4376 80.625 92.1876 79.8438 86.7188 76.7188C81.2501 73.5938 76.9532 68.9063 74.6094 63.0469C72.2657 57.1875 71.8751 50.5469 73.8282 44.6875C75.7813 38.4375 79.2969 33.3594 84.7657 29.8438C89.8438 26.3281 96.0938 24.7656 102.344 25.1562ZM104.297 75.5469C109.375 74.375 114.063 71.6406 117.578 67.3438C120.703 63.0469 122.656 57.9688 122.266 52.5C122.266 46.25 119.922 40 115.625 35.7031C111.719 31.7969 107.031 29.4531 101.563 29.0625C96.4844 28.6719 91.0157 29.8438 86.7188 32.9688C82.4219 36.0938 79.2969 40.3906 77.7344 45.8594C76.1719 50.9375 76.1719 56.4063 78.5157 61.4844C80.8594 66.5625 84.3751 70.4688 89.0626 73.2031C93.7501 75.9375 99.2188 76.7188 104.297 75.5469ZM99.6094 50.5469L108.984 40.7812L111.719 43.5156L102.344 53.2812L111.719 63.0469L108.984 65.7813L99.6094 56.0156L90.2344 65.7813L87.5001 63.0469L96.8751 53.2812L87.5001 43.5156L90.2344 40.7812L99.6094 50.5469Z",
    fill: "#D0342C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.661 114.482L184.178 188.697C183.653 192.407 180.478 195.165 176.731 195.165H26.9524C23.2056 195.165 20.0304 192.407 19.5062 188.697L5.33843 88.4149C4.69935 83.8877 8.21238 79.8428 12.7846 79.8428H59.0395C62.7862 79.8428 65.9615 82.6002 66.4856 86.3097L68.3423 99.4424C68.8665 103.153 72.0417 105.91 75.7885 105.91H187.217C191.788 105.91 195.301 109.955 194.662 114.482H194.661Z",
    fill: "#B4DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.515 162.062H46.1694C45.5591 162.062 44.9698 161.839 44.5119 161.435C44.054 161.032 43.759 160.475 43.6821 159.87L42.289 148.84C42.2448 148.487 42.2761 148.129 42.3808 147.789C42.4855 147.449 42.6613 147.135 42.8965 146.869C43.1318 146.602 43.421 146.388 43.7451 146.242C44.0691 146.096 44.4207 146.02 44.7763 146.02H158.909C159.264 146.02 159.616 146.096 159.94 146.242C160.264 146.388 160.553 146.602 160.788 146.869C161.023 147.135 161.199 147.449 161.304 147.789C161.409 148.129 161.44 148.487 161.396 148.84L160.003 159.87C159.926 160.475 159.631 161.032 159.173 161.435C158.715 161.839 158.126 162.062 157.515 162.062Z",
    fill: "#1485FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6363_63850",
    x: 17.6519,
    y: -3.83594,
    width: 168.381,
    height: 159.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6363_63850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6363_63850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6363_63850",
    x1: 106.252,
    y1: 84.2457,
    x2: 11.1501,
    y2: -10.8568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6363_63850",
    x1: 81.0587,
    y1: 111.318,
    x2: 51.6694,
    y2: 81.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6363_63850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteForm);
export default __webpack_public_path__ + "static/media/deleteForm.e7e5096de650679936438a652a6afdad.svg";
export { ForwardRef as ReactComponent };